export enum TypeOfApplicantEnum{
    Individual = 1,
    Company = 2
}